import React from "react";
import "./Coin.css";
import { useNavigate } from "react-router-dom";


function Coin(props) {

  const history =  useNavigate();
  const abc = path => {
    history(path);
  };


  var fh =  props.volume.toString().length

  const usd_price = props.current_price

  const inr_price = props.current_price

  const volume_usd_price = props.volume

  const volume_inr_price = props.volume

  const market_usd_price = props.market_cap

  const market_inr_price = props.market_cap

let dollarUS = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});

let rupeeIndian = Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
});



  return (
    <>
    <div className="coin-container">
      <div className="coin-row"  onClick={() => abc(`/coin/${props.id}`)}>
        <div className="coin">
          <p className="rank-para">{props.rank}.</p>
          <img src={props.image} alt="crypto-symbol" />
          <h1>{props.name}</h1>
          <p className="coin-symbol">{props.symbol}</p>
        </div>

        <div className="coin-data">
        {props.currency === "USD" ? ( <p className="coin-price">
            {dollarUS.format(usd_price)}
          </p>):( <p className="coin-price">
            {rupeeIndian.format(inr_price)}
          </p>)}
         
          {props?.priceChange < 0 ? (
            <p className="coin-percent red">{props?.priceChange.toFixed(2)}%</p>
          ) : (
            <p className="coin-percent green">
              +{props?.priceChange.toFixed(2)}%
            </p>
          )}

          <p className="coin-new-volume">
          {props.currency === "USD" ? ( <p>
            {dollarUS.format(volume_usd_price)}
          </p>):( <p>
            {rupeeIndian.format(volume_inr_price)}
          </p>)}
          </p>

          <p className="coin-marketcap">
          {props.currency === "USD" ? ( <p>
            {dollarUS.format(market_usd_price)}
          </p>):( <p>
            {rupeeIndian.format(market_inr_price)}
          </p>)}
          </p>
        </div>
      </div>
    </div>
    </>
  );
  
}

export default Coin;
